import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const interactionImporterSelectors = importerSelectors(
  'interaction.importer',
);

export default interactionImporterSelectors;
